import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { MappedName, ViewabilityMetricsByDim } from '@pubstack/common/src/analytics/query'
import { CurrencySymbol } from '@pubstack/common/src/currency'
import { FunctionComponent } from 'react'
import { useAnalyticsQueryTanstack } from '~/api/analytics/analytics-query.api'
import { Context } from '~/state'
import { TabConfig } from '~/utils/analytics'
import { PureViewabilityBreakdown } from './PureViewabilityBreakdown'

type ViewabilityBreakdownProps = {
  context: Context
  dimensions: Dimension[]
  dimension: Dimension
  currencySymbol: CurrencySymbol
  onTabChange: (dimension: Dimension) => void
  onRowClick: (name: MappedName) => void
  tabsConfig: TabConfig[]
  showMinorData?: boolean
}

export const ViewabilityBreakdown: FunctionComponent<ViewabilityBreakdownProps> = ({ context, dimensions, dimension, currencySymbol, onTabChange, onRowClick, tabsConfig, showMinorData }) => {
  const analyticsQuery = useAnalyticsQueryTanstack<ViewabilityMetricsByDim>('viewability.metrics.by.dim', dimensions, context, { dimension })

  return (
    <PureViewabilityBreakdown
      isLoading={analyticsQuery.isFetching}
      error={!!analyticsQuery.error}
      empty={!analyticsQuery.isLoading && !analyticsQuery.data?.name?.length}
      onRefreshClick={() => analyticsQuery.refetch()}
      rawData={analyticsQuery.data ?? { name: [] }}
      onTabChange={onTabChange}
      currencySymbol={currencySymbol}
      onRowClick={onRowClick}
      onSortChange={() => {}}
      tabsConfig={tabsConfig}
      showMinorData={showMinorData}
    />
  )
}
